import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import setupAxiosInterceptors from './utils/axiosInterceptor'
import permissionMixin from '@/utils/permissionMixin'; // ອ້າງອີງໄປຫາໄຟລ໌ mixin ຂອງທ່ານ

// ລົງທະບຽນໃຫ້ເປັນ Global Mixin
Vue.mixin(permissionMixin);
 
Vue.config.productionTip = false

// Setup axios interceptors for handling token expiry
const interceptors = setupAxiosInterceptors(router);
axios.interceptors.response.use(
  interceptors.interceptors.response.onFulfilled,
  interceptors.interceptors.response.onRejected
);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
